module.exports = __webpack_public_path__ + "img/bumblebee.b39a61df.png";